export const CLASS_IS_ACTIVE = "is--active";
export const CLASS_IS_DISABLED = "is--disabled";
export const CLASS_IS_FINISH = "is--finish";
export const CLASS_IS_HIDE = "is--hide";
